import React, { useState } from "react";
import { Steps, Typography } from "antd";
import Accountsignup from "../Accountsignup/Accountsignup";
import CreateAccount from "../CreateAccount/CreateAccount";
import Password from "../Password/Password";
import { UserRegister } from "../../utils/apiCalls";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader";
import ReusableModal from "../ReusableModal/ReusableModal";

const initialValue = {
  firstName: "",
  lastName: "",
  userName: "",
  email: "",
  mobileNumber: "",
  departmentId: null,
  accessLevelId: null,
  password: "",
  confirmPassword: "",
};

const Stepper = () => {
  const navigate = useNavigate();
  const [current, setCurrent] = useState(0);
  const [registerData, setRegisterData] = useState(initialValue);
  const [openModal, setOpenModal] = useState(false);
  const [messages, setMessages] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState();

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const handleOk = () => {
    setOpenModal(false);
    if (status === 200) navigate("/");
  };
  const handleSubit = () => {
    setIsLoading(true);
    const payload = {
      firstName: registerData?.firstName,
      lastName: registerData?.lastName,
      userName: registerData?.userName,
      email: registerData?.email,
      mobileNumber: registerData?.mobileNumber,
      departmentId: parseInt(registerData?.departmentId),
      accessLevelId: parseInt(registerData?.accessLevelId),
      password: registerData?.password,
    };
    UserRegister((res) => {
      const { statusCode, message } = res;
      setStatus(statusCode);
      if (statusCode === 200) {
        setIsLoading(false);
        setOpenModal(true);
        setMessages("User Registered Successfully.");
      } else {
        setOpenModal(true);
        setMessages(message ?? "Something went wrong.");
        setIsLoading(false);
      }
    }, payload);
  };

  return (
    <>
      <Steps style={{ marginBottom: "20px" }} current={current} items={[{}, {}, {}]} responsive />
      <div>
        {current === 0 && (
          <Accountsignup
            registerData={registerData}
            setRegisterData={setRegisterData}
            onNext={next}
            onBack={prev}
            isBackDisabled={current === 0}
          />
        )}
        {current === 1 && (
          <CreateAccount
            registerData={registerData}
            setRegisterData={setRegisterData}
            onNext={next}
            onBack={prev}
          />
        )}
        {current === 2 && (
          <Password
            registerData={registerData}
            setRegisterData={setRegisterData}
            onNext={handleSubit}
            onBack={prev}
          />
        )}
      </div>
      {isLoading && (
        <div className="loader-container">
          <Loader />
        </div>
      )}
      {openModal && (
        <ReusableModal
          children={<Typography style={{ fontSize: "20px", fontWeight: "bold", textAlign: "center", marginBottom: "15px" }}>
            {messages}
          </Typography>}
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          onOk={handleOk}
        />
      )}
    </>
  );
};

export default Stepper;
